import { render, staticRenderFns } from "./DataMap.vue?vue&type=template&id=8943dec2&"
import script from "./DataMap.vue?vue&type=script&lang=js&"
export * from "./DataMap.vue?vue&type=script&lang=js&"
import style0 from "./DataMap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports